export const privacy = {
  "header": {
    "badge": "Dados pessoais",
    "title": "política de Privacidade"
  },
  "content": {
    "intro": "A proteção da sua privacidade e dos seus dados pessoais é uma prioridade absoluta para a DONKEY TRAVEL. Esta política detalha como coletamos, processamos e protegemos suas informações.",
    "collection": {
      "title": "1. Coleta de dados",
      "text": "Recolhemos apenas os dados estritamente necessários ao bom funcionamento da plataforma: os seus dados de criação de conta (apelido, nome, email), links para os seus anúncios públicos (Airbnb), e as suas preferências e disponibilidade de viagem. As senhas são criptografadas e os dados de pagamento são processados ​​pelo nosso parceiro seguro Stripe."
    },
    "usage": {
      "title": "2. Utilização dos seus dados",
      "text": "Suas informações são usadas para: \n- Verifique sua elegibilidade (classificação 4,5+) \n- Gerencie sua assinatura \n- Facilitar a conexão com outros membros \n- Forneça recomendações personalizadas por meio de nossa correspondência inteligente \n- Melhorar nossos serviços e resolver problemas técnicos."
    },
    "sharing": {
      "title": "3. Compartilhamento de informações",
      "text": "NUNCA venderemos seus dados pessoais a terceiros. A sua partilha é estritamente limitada a fins operacionais com os nossos prestadores de serviços de confiança (hospedagem web, ferramenta de pagamento). Fora deste quadro, os seus dados só são partilhados entre membros para a organização de uma troca (e apenas o endereço exato após validação de uma troca)."
    },
    "security": {
      "title": "4. Segurança",
      "text": "Os protocolos de autenticação e segurança mais robustos estão em vigor para proteger os seus dados contra acesso não autorizado, alteração, divulgação ou destruição."
    },
    "rights": {
      "title": "5. Seus direitos (RGPD)",
      "text": "De acordo com o Regulamento Geral de Proteção de Dados, tem o direito de acesso, retificação, portabilidade ou eliminação dos seus dados pessoais a qualquer momento. Você pode exercer esse direito nas configurações da sua conta ou escrevendo para dpo@donkey.travel."
    },
    "cookies": {
      "title": "6. Biscoitos",
      "text": "Utilizamos cookies essenciais para manter a sua sessão de login, bem como cookies analíticos anónimos para compreender como o nosso site é utilizado e melhorar a sua experiência."
    }
  }
};
